// The Bricks `ValidatedTextInput` (format="emailAddress") validated email input
// with `validator.isEmail` plus a blacklist of common typo TLDs, which kept
// fat-finger addresses out of lead capture. cosmos does not depend on
// `validator` directly (it was only transitive via bricks-next), so the format
// check uses the WHATWG/HTML5 email pattern and preserves the original TLD
// blacklist instead of pulling in a new dependency.
const BLACKLISTED_TLDS = ['como', 'comp', 'con', 'met', 'ner', 'vom'];

// HTML5 living-standard email validation pattern (requires a dotted domain).
const EMAIL_REGEX =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;

export const isValidEmailAddress = (value: string): boolean => {
  if (!EMAIL_REGEX.test(value)) {
    return false;
  }
  const tld = value.split('.').pop()?.toLowerCase();
  return tld ? !BLACKLISTED_TLDS.includes(tld) : true;
};
